import { render, staticRenderFns } from "./wholesale-sidebar.vue?vue&type=template&id=39ae7040&scoped=true"
import script from "./wholesale-sidebar.vue?vue&type=script&lang=js"
export * from "./wholesale-sidebar.vue?vue&type=script&lang=js"
import style0 from "./wholesale-sidebar.vue?vue&type=style&index=0&id=39ae7040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae7040",
  null
  
)

export default component.exports